import React, { Component } from 'react';
import { connect } from 'react-redux';

import Layout from 'Components/Layout/Layout';
import { withRouter } from 'react-router';

class OAuthLanding extends Component {
  componentDidMount() {
    window.opener.focus();
    window.opener.postMessage(
      {
        type: 'oauth_token_received',
        provider: this.props.match.params.provider,
        url: window.location.href,
      },
      window.location.origin
    );
    window.close();
  }

  render() {
    return <Layout>Loading...</Layout>;
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(withRouter(OAuthLanding));



// WEBPACK FOOTER //
// ./src/Components/Pages/Auth/OAuthLanding.js